import { Children } from "react";
import { useState, useEffect, useDeferredValue } from "react";
import {
  HeaderContainer,
  MainButton,
  RightMainContainer,
  PrimaryHeading,
  BodyContainer,
  InputField,
  ListCard,
  ListIconWrapper,
  PopOver,
  AddFromTemplateLibrary,
  LoadingListCards,
  TemplateNotFound,
  Loader,
  FiltersList,
} from "commonUI";
import { AddIcon, NotesIcon } from "allIcons";
import {
  useAddDefaultNote,
  useRemoveDefaultNote,
  useTemplateNotes,
  useDefaultNotes,
} from "api/templateLibrary/notes";
import { search } from "helpers";
import {
  libraryItemFiltering,
  libraryItemSorting,
} from "filterAndSort/templateLibrary";
import { useTags } from "api/siteSettings/Tags";
import { useUserPermissions } from "hooks/user";
import { t } from "i18next";
import { ModulePrefixes } from "enums";

export default function Notes() {
  const {
    data: notes
  } = useTemplateNotes();
  const [addPopUp, setAddPopUp] = useState(false);

  const {
    data: defaultNotes,
    isLoading: defaultNotesLoading
  } = useDefaultNotes();
  const [filteredDefaultNotes, setFilteredDefaultNotes] = useState([]);

  const addMutation = useAddDefaultNote();
  const removeMutation = useRemoveDefaultNote();
  const { data: tags } = useTags();

  const [searchText, setSearchText] = useState("");
  const defferedSearch = useDeferredValue(searchText);
  const [filterData, setFilterData] = useState({});
  const {
    remove_items_from_site_template,
    edit_templates
  } = useUserPermissions();

  useEffect(() => {
    setFilteredDefaultNotes(
      defaultNotes.filter((note) => search(note.title, defferedSearch))
    );
  }, [defaultNotes, defferedSearch]);

  const applySorting = (order, orderBy) => {
    setFilteredDefaultNotes((prevSearchResult) =>
      libraryItemSorting(order, orderBy, prevSearchResult)
    );
  };

  const applyFilter = ({
    selectedFilter,
    selectedTags,
    selectedLibrarySource,
    ...data
  }) => {
    setFilterData({
      ...data,
      selectedTags,
      selectedLibrarySource,
      selectedFilter,
    });
    setFilteredDefaultNotes(
      libraryItemFiltering(
        selectedFilter,
        selectedTags,
        selectedLibrarySource,
        defaultNotes
      )
    );
  };

  return (
    <>
      <RightMainContainer>
        {addMutation.isLoading || removeMutation.isLoading ? (
          <Loader loader="block" />
        ) : (
          ""
        )}
        <HeaderContainer>
          <PrimaryHeading>{t("libraryTemplate.notes.title")}</PrimaryHeading>
          <div className="relative">
            <MainButton onClick={() => setAddPopUp(!addPopUp)}>
              <AddIcon fill="white" />
              {t("button.add")}
            </MainButton>
            <PopOver open={addPopUp} onClose={() => setAddPopUp(false)}>
              <AddFromTemplateLibrary
                heading={t("common.addFromTemplateLibraryTitle")}
                data={
                  notes
                    .filter(
                      (note) =>
                        note.default_tem === undefined || note.default_tem === null || note.default_tem === "0"
                    )
                    .map((note) => ({
                      ...note,
                      icon: <NotesIcon fill="white" />,
                      onClick: () =>
                        addMutation.mutate({
                          id: note.id,
                        }),
                    })) || []
                }
                emptyTemplate={{
                  label: t("libraryTemplate.notes.title"),
                  link: `/${ModulePrefixes.TEMPLATE_LIBRARY}/notes/add`,
                  linkLabel: t("libraryTemplate.note"),
                }}
              />
            </PopOver>
          </div>
        </HeaderContainer>
        <BodyContainer>
          <InputField
            placeholder={t("input.search.placeholder")}
            searchIcon={true}
            filter={true}
            value={searchText}
            setValue={(value) => setSearchText(value)}
            showLibrarySource={false}
            tags={tags}
            onApplyFilter={applyFilter}
            applySorting={applySorting}
            filterData={filterData}
          />
          <FiltersList filterData={filterData} updateFilter={applyFilter} />
          {defaultNotesLoading ? <LoadingListCards /> : Children.toArray(
            filteredDefaultNotes.length > 0 ? (
              filteredDefaultNotes.map((note, index) => (
                <ListCard
                  editIcon={edit_templates}
                  link={
                    edit_templates ? `/${ModulePrefixes.SITE_TEMPLATE}/library-item/notes/${note.id}` : ""
                  }
                  strictLink={true}
                  data={note.title}
                  onCross={() => {
                    removeMutation.mutate(note.id);
                  }}
                  icon={
                    <ListIconWrapper>
                      <NotesIcon fill="white" />
                    </ListIconWrapper>
                  }
                  deleteIcon
                  crossIcon={remove_items_from_site_template}
                  showModalonCross
                  deleteTitle={t("siteSetting.libraryTemplate.removeTemplate.title")}
                  deleteButtonText={t("siteSetting.libraryTemplate.removeTemplate.button")}
                  deleteMessage={t("siteSetting.libraryTemplate.removeTemplate.message")}
                />
              ))
            ) : !defaultNotesLoading ? (
              <TemplateNotFound
                label={t("libraryTemplate.notes.title")}
                linkLabel={t("libraryTemplate.note")}
                onClick={() => setAddPopUp(true)}
              />
            ) : (
              ""
            )
          )}
        </BodyContainer>
      </RightMainContainer>
    </>
  );
}
